interface HexProps {
  size?: number;
}

/**
 * Stylized hexagon mark — VibeProSoft-style geometric brand placeholder.
 * Blue gradient base + amber spark accent. Used as the favicon-shaped element
 * inside the Logo lockup.
 */
export function HexLogo({ size = 32 }: HexProps) {
  return (
    <svg className="gw-logo__hex" width={size} height={size} viewBox="0 0 64 64" fill="none">
      <defs>
        <linearGradient id="hexg" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#60a5fa" />
          <stop offset="1" stopColor="#1d4ed8" />
        </linearGradient>
        <linearGradient id="hexgInner" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#fcd34d" />
          <stop offset="1" stopColor="#f59e0b" />
        </linearGradient>
      </defs>
      <polygon points="32,3 58,18 58,46 32,61 6,46 6,18" fill="url(#hexg)" />
      <polygon points="32,9 53,21 53,43 32,55 11,43 11,21" fill="#050810" />
      <polygon points="32,14 48,23 48,41 32,50 16,41 16,23" fill="url(#hexg)" opacity="0.2" />
      <path d="M22 24 L32 18 L42 24 L42 40 L32 46 L22 40 Z" stroke="#60a5fa" strokeWidth="1.4" fill="none" opacity="0.6" />
      <circle cx="32" cy="32" r="4" fill="url(#hexgInner)" />
      <circle cx="32" cy="32" r="2" fill="#fff" opacity="0.9" />
    </svg>
  );
}

interface LogoProps {
  hero?: boolean;
  subBrand?: string;
  onClick?: () => void;
}

/**
 * VibeProSoft / Ghostwire AI lockup. `hero` variant is for the sign-in marquee;
 * default is sized for the header.
 */
export function Logo({ hero = false, subBrand = 'Ghostwire AI', onClick }: LogoProps) {
  return (
    <div className={`gw-logo ${hero ? 'gw-logo--hero' : ''}`} onClick={onClick}>
      <HexLogo size={hero ? 64 : 32} />
      <div className="gw-logo__wm">
        <span className="vps">VibeProSoft</span>
        <span className="gw">{subBrand}</span>
      </div>
    </div>
  );
}
